import { render, staticRenderFns } from "./Queries.vue?vue&type=template&id=1b8d9750&scoped=true&"
import script from "./Queries.vue?vue&type=script&lang=js&"
export * from "./Queries.vue?vue&type=script&lang=js&"
import style0 from "./Queries.vue?vue&type=style&index=0&id=1b8d9750&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d9750",
  null
  
)

export default component.exports